import { z } from "zod";
import { extendZodWithOpenApi } from "zod-openapi";
import { successResponse, tagPaths, unref } from "../util.ts";
import { created_at, int, storage_pool_uuid, uuid } from "./common.ts";
import * as params from "./params.ts";

extendZodWithOpenApi(z);

const Limit = z
    .object({
        min: z.number().min(0),
        max: z.number().min(0),
    })
    .describe("Inclusive minimum and maximum values")
    .openapi({ ref: "Limit" });

export const GuestLimits = z
    .object({
        cpu: unref(Limit).describe("Allowed vCPU count range for a VM in this pool"),
        disk_gb: unref(Limit).describe("Allowed disk size range in GiB for a VM in this pool"),
        ram_mb: unref(Limit).describe("Allowed RAM size range in MiB for a VM in this pool"),
    })
    .describe("Per-pool VM resource bounds")
    .openapi({ ref: "GuestLimits" });

export const HostPool = z
    .object({
        uuid,

        name: z.string(),
        description: z.string().optional(),
        is_visible: z.boolean().describe("Whether the pool is shown to end users"),
        is_default_designated: z
            .boolean()
            .describe("Whether this pool is preselected for new VM creation when no other pool is chosen"),
        ui_position: int.optional().describe("Ordering index used in UI lists"),
        storage_pool_uuid: unref(storage_pool_uuid).describe("Default block storage pool for VMs created in this pool"),
        guest_limits: GuestLimits.optional(),

        created_at,
        updated_at: created_at.optional(),
    })
    .openapi({ ref: "HostPool" });

export const HostPoolResponse = z.array(HostPool);

export const hostPoolPaths = tagPaths("host_pool")({
    "/{location}/user-resource/host_pool/list": {
        get: {
            summary: "List Host Pools",
            parameters: [params.location],
            responses: {
                ...successResponse(HostPoolResponse),
            },
        },
    },
});
